import type { ReactNode } from 'react'
import { Tag } from '@/components/tag/Tag'
import type { ColumnTag } from '../schemas'
import { customTagColors } from '../utils/tag-colors'

/** Preserve the exact label while sharing colors between option editing and saved cells. */
export default function TableTag({ tag, children }: { tag: ColumnTag; children?: ReactNode }) {
  if (tag.custom_color) {
    return (
      <span
        className="inline-flex min-h-5 max-w-full items-center justify-center gap-0.5 rounded border px-1 py-px text-xs font-medium leading-4 break-words"
        style={customTagColors(tag.custom_color)}
      >
        {children ?? tag.label}
      </span>
    )
  }
  return (
    <span className="inline-flex max-w-full [&>span]:min-h-5 [&>span]:max-w-full [&>span]:whitespace-normal [&>span]:break-words [&>span]:leading-4">
      <Tag color={tag.color} size="xs" textCase="normal">
        {children ?? tag.label}
      </Tag>
    </span>
  )
}
